import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const workshopService = {
    async list(query = {}) {
        const { data } = await api.get("/workshop", { params: toParams(query) });
        return data;
    },
    async get(id) {
        const { data } = await api.get(`/workshop/${id}`);
        return data;
    },
    async getByWorkOrder(workOrderId) {
        const { data } = await api.get(`/workshop/by-work-order/${workOrderId}`);
        return data && data.id ? data : null;
    },
    async meta() {
        const { data } = await api.get("/workshop/meta");
        return data;
    },
    async dashboard() {
        const { data } = await api.get("/workshop/dashboard");
        return data;
    },
    async receive(id, payload) {
        const { data } = await api.post(`/workshop/${id}/receive`, payload);
        return data;
    },
    async updateChecklist(id, payload) {
        const { data } = await api.patch(`/workshop/${id}/checklist`, payload);
        return data;
    },
    async startDiagnosis(id) {
        const { data } = await api.post(`/workshop/${id}/start-diagnosis`);
        return data;
    },
    async updateDiagnosis(id, payload) {
        const { data } = await api.patch(`/workshop/${id}/diagnosis`, payload);
        return data;
    },
    async updateLaborEstimation(id, payload) {
        const { data } = await api.patch(`/workshop/${id}/labor-estimation`, payload);
        return data;
    },
    async addService(id, payload) {
        const { data } = await api.post(`/workshop/${id}/services`, payload);
        return data;
    },
    async removeService(id, serviceId) {
        const { data } = await api.delete(`/workshop/${id}/services/${serviceId}`);
        return data;
    },
    async addPart(id, payload) {
        const { data } = await api.post(`/workshop/${id}/parts`, payload);
        return data;
    },
    async removePart(id, partId) {
        const { data } = await api.delete(`/workshop/${id}/parts/${partId}`);
        return data;
    },
    async updateTechnicalReport(id, payload) {
        const { data } = await api.patch(`/workshop/${id}/technical-report`, payload);
        return data;
    },
    async addPhoto(id, payload) {
        const { data } = await api.post(`/workshop/${id}/photos`, payload);
        return data;
    },
    async removePhoto(id, photoId) {
        const { data } = await api.delete(`/workshop/${id}/photos/${photoId}`);
        return data;
    },
    async finish(id) {
        const { data } = await api.post(`/workshop/${id}/finish`);
        return data;
    },
    async remove(id) {
        await api.delete(`/workshop/${id}`);
    },
};
